export const isVideo = mediaType => mediaType?.toUpperCase() === 'VIDEO'

export const getFileName = fileUrl => {
  if (!fileUrl) return ''
  const parts = fileUrl.split('/')
  return parts[parts.length - 1] || ''
}

export const formatCustomerDisplayDate = value => {
  if (!value) return '—'
  return new Date(value).toLocaleDateString('es-NI')
}

export const buildCustomerDisplaySearchPayload = ({
  startDate,
  endDate,
  pagination,
  selectedCompany,
  selectedBranchOffice,
  selectedMediaType,
  searchText,
}) => {
  const payload = {
    PageNumber: pagination.currentPage,
    PageSize: pagination.pageSize,
  }

  if (startDate) payload.StartDate = startDate
  if (endDate) payload.EndDate = endDate
  if (selectedCompany) payload.CompanyId = selectedCompany
  if (selectedBranchOffice) payload.BranchOfficeId = selectedBranchOffice
  if (selectedMediaType) payload.MediaType = selectedMediaType
  if (searchText) payload.SearchText = searchText

  return payload
}

const getPageDisplayOrderFallback = ({ currentPage, pageSize }, index) => {
  const page = Math.max(Number(currentPage) || 1, 1)
  const size = Math.max(Number(pageSize) || 0, 0)

  return (page - 1) * size + index + 1
}

const getDisplayOrderSlots = (currentItems, pagination) =>
  currentItems.map((item, index) => {
    const displayOrder = Number(item.DisplayOrder)
    const hasDisplayOrder =
      item.DisplayOrder !== null &&
      item.DisplayOrder !== undefined &&
      item.DisplayOrder !== ''

    return hasDisplayOrder && Number.isFinite(displayOrder)
      ? displayOrder
      : getPageDisplayOrderFallback(pagination, index)
  })

export const buildCustomerDisplayReorderChanges = ({
  currentItems,
  reorderedItems,
  pagination,
}) => {
  const displayOrderSlots = getDisplayOrderSlots(currentItems, pagination)
  const previousOrderById = new Map(
    currentItems.map((item, index) => [
      item.CustomerDisplaySettingId,
      displayOrderSlots[index],
    ])
  )
  const previousItemById = new Map(
    currentItems.map(item => [item.CustomerDisplaySettingId, item])
  )

  const changedItems = []
  const rollbackItems = []
  const updatedItems = reorderedItems.map((item, index) => {
    const nextDisplayOrder = displayOrderSlots[index]
    const previousDisplayOrder = previousOrderById.get(
      item.CustomerDisplaySettingId
    )

    if (previousDisplayOrder === nextDisplayOrder) return item

    const updatedItem = { ...item, DisplayOrder: nextDisplayOrder }
    changedItems.push(updatedItem)
    rollbackItems.push(previousItemById.get(item.CustomerDisplaySettingId))
    return updatedItem
  })

  return { updatedItems, changedItems, rollbackItems }
}

const updateItemsWithRetry = async ({ items, updateItem, maxAttempts }) =>
  Promise.all(
    items.map(async item => {
      for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        try {
          if (await updateItem(item)) return true
        } catch (error) {
          // Retry rejected requests just like unsuccessful responses.
        }
      }

      return false
    })
  )

export const persistCustomerDisplayReorderChanges = async ({
  changedItems,
  rollbackItems,
  updateItem,
  refreshItems,
  maxAttempts = 2,
}) => {
  const results = await updateItemsWithRetry({
    items: changedItems,
    updateItem,
    maxAttempts,
  })
  const success = results.every(Boolean)

  if (success) {
    return { success: true, rollbackSucceeded: true }
  }

  const rollbackResults = await updateItemsWithRetry({
    items: rollbackItems,
    updateItem,
    maxAttempts,
  })
  const rollbackSucceeded = rollbackResults.every(Boolean)

  await refreshItems()

  return { success: false, rollbackSucceeded }
}

export const tryAcquireCustomerDisplayReorderLock = lockRef => {
  if (lockRef.current) return false

  lockRef.current = true
  return true
}

export const mapCustomerDisplayUpdatePayload = (item, status) => {
  const payload = {
    CustomerDisplaySettingId: item.CustomerDisplaySettingId,
    Name: item.Name,
    MediaType: item.MediaType,
    FileUrl: item.FileUrl,
    DisplayOrder: item.DisplayOrder,
    StartDate: item.StartDate,
    EndDate: item.EndDate,
    CompanyId: item.CompanyId,
    Status: status,
  }

  if (Array.isArray(item.BranchOffices)) {
    payload.BranchOffices = item.BranchOffices.map(branchOffice => ({
      BranchOfficeId: branchOffice.BranchOfficeId,
    }))
  }

  return payload
}
